// The carousel is managed in the content API admin (About carousel section): upload, reorder,
// edit alt text and caption, delete. Nothing here needs editing for that.
// Images below is the BUILT-IN FALLBACK: it is shown when the API is not configured, not
// reachable, or has no carousel photos, so the About section is never blank.
//
// To add a built-in photo: drop the file into public/images/aboutme/ and add one line to Images.
// No import, no component change. caption is optional and is used as the image's alt text.
// Existing photos keep their original file names.
export const aboutme = {
  Title: 'About Me',
  Main: 'With a solid academic foundation and hands-on experience as a .NET Developer, I am well-equipped to tackle complex challenges and exceed client expectations. My expertise includes working with ASP.NET, C#, Angular/React, and developing scalable solutions with WCF services and .NET Core APIs at an Enterprise Service Bus level. I have experience building and maintaining backend systems, collaborating with teams to implement Clean Architecture principles, and contributing to large-scale initiatives.',
  Images: [
    { src: '/images/aboutme/about1.JPEG' },
    { src: '/images/aboutme/about2.JPEG' },
    { src: '/images/aboutme/about3.JPEG' },
    { src: '/images/aboutme/about4.jpg' },
  ],
};
